import { render, staticRenderFns } from "./FormaPagamentoSelect.vue?vue&type=template&id=050cc90a"
import script from "./FormaPagamentoSelect.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports